module.exports = __webpack_public_path__ + "img/IMG_7102.70c08bc7.webp";